import {
  VisaIcon as SharedVisaIcon,
  AmexIcon as SharedAmexIcon,
  ApplePayIcon as SharedApplePayIcon,
  GooglePayIcon as SharedGooglePayIcon,
  MastercardIcon as SharedMastercardIcon,
  DiscoverIcon as SharedDiscoverIcon,
} from "@vendistri/ui";

// Explicit local exports keep existing consumers stable through dev-server updates.
export const VisaIcon = SharedVisaIcon;
export const AmexIcon = SharedAmexIcon;
export const ApplePayIcon = SharedApplePayIcon;
export const GooglePayIcon = SharedGooglePayIcon;
export const MastercardIcon = SharedMastercardIcon;
export const DiscoverIcon = SharedDiscoverIcon;
